export default function ProgressBar({ value = 0, className = "" }) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div className={`h-2.5 w-full rounded-full bg-brand-navy/10 overflow-hidden ${className}`}>
      <div
        className="h-full rounded-full bg-brand-orange transition-all duration-500"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
